/**
 * Centraliserad färgmappning för yrkesgrupper
 * Används i Kalkyl, PU och Offert för visuell färgkodning
 * Varje yrkesgrupp har en unik färg
 */

// Direkt färgmappning för varje yrkesgrupp
const YRKESGRUPP_COLORS = {
  // === HUVUDFÄRGER (reserverade) ===

  // Orange - Byggnation
  'Byggnation': { bg: 'bg-orange-500', border: 'border-l-orange-500', hex: '#f97316' },

  // Grön - Elektriker
  'Elektriker': { bg: 'bg-green-500', border: 'border-l-green-500', hex: '#22c55e' },

  // Blå - VVS
  'VVS-installatör': { bg: 'bg-blue-500', border: 'border-l-blue-500', hex: '#3b82f6' },
  'VVS-installatör (ej ROT)': { bg: 'bg-blue-500', border: 'border-l-blue-500', hex: '#3b82f6' },
  'VVS-installatör (Ej ROT)': { bg: 'bg-blue-500', border: 'border-l-blue-500', hex: '#3b82f6' },

  // Röd - Rivning
  'Rivning': { bg: 'bg-red-500', border: 'border-l-red-500', hex: '#ef4444' },

  // Gul - Snickeri
  'Snickeri': { bg: 'bg-yellow-400', border: 'border-l-yellow-400', hex: '#facc15' },

  // === ÖVRIGA FÄRGER (tydligt skilda) ===

  // Lila nyanser - Måleri
  'Underarbete': { bg: 'bg-purple-500', border: 'border-l-purple-500', hex: '#a855f7' },
  'Finisharbete': { bg: 'bg-purple-500', border: 'border-l-purple-500', hex: '#a855f7' },

  // Rosa nyanser
  'Fönstermontage': { bg: 'bg-pink-400', border: 'border-l-pink-400', hex: '#f472b6' },
  'Fönsterdörrmontage': { bg: 'bg-rose-400', border: 'border-l-rose-400', hex: '#fb7185' },

  // Turkos/Cyan - Plattsättning (samma färg då de utförs av samma yrkesperson)
  'Tätskikt': { bg: 'bg-teal-500', border: 'border-l-teal-500', hex: '#14b8a6' },
  'Flytspackling': { bg: 'bg-teal-500', border: 'border-l-teal-500', hex: '#14b8a6' },
  'Plattsättning': { bg: 'bg-teal-500', border: 'border-l-teal-500', hex: '#14b8a6' },
  'Plattsättare': { bg: 'bg-teal-500', border: 'border-l-teal-500', hex: '#14b8a6' },

  // Grön/Lime - Golv (alla golvpunkter delar SAMMA färg → grupperas som "Golv")
  // OBS: 'Fiskbensparkett' var tidigare felstavad ('Fiskebenparkett') → blev ofärgad.
  'Nota': { bg: 'bg-lime-500', border: 'border-l-lime-500', hex: '#84cc16' },
  'Slipa (lack)': { bg: 'bg-lime-500', border: 'border-l-lime-500', hex: '#84cc16' },
  'Slipa (hårdvax)': { bg: 'bg-lime-500', border: 'border-l-lime-500', hex: '#84cc16' },
  'Slipa (luta)': { bg: 'bg-lime-500', border: 'border-l-lime-500', hex: '#84cc16' },
  'Slipa (grov)': { bg: 'bg-lime-500', border: 'border-l-lime-500', hex: '#84cc16' },
  'Fiskbensparkett': { bg: 'bg-lime-500', border: 'border-l-lime-500', hex: '#84cc16' },
  'Fiskebenparkett': { bg: 'bg-lime-500', border: 'border-l-lime-500', hex: '#84cc16' }, // legacy felstavning — färgsätt ändå
  'Massiv parkett (fallande L)': { bg: 'bg-lime-500', border: 'border-l-lime-500', hex: '#84cc16' },
  'Mattläggning': { bg: 'bg-lime-500', border: 'border-l-lime-500', hex: '#84cc16' },

  // Mörka/Bruna nyanser - Bygg-relaterade
  'Grundarbete': { bg: 'bg-stone-500', border: 'border-l-stone-500', hex: '#78716c' },
  'Stomarbete': { bg: 'bg-amber-700', border: 'border-l-amber-700', hex: '#b45309' },
  'Murarbete': { bg: 'bg-red-700', border: 'border-l-red-700', hex: '#b91c1c' },
  'Takarbete': { bg: 'bg-stone-600', border: 'border-l-stone-600', hex: '#57534e' },
  'Plåtarbete': { bg: 'bg-indigo-400', border: 'border-l-indigo-400', hex: '#818cf8' },

  // Indigo/Mörklila - Specialister
  'Gas-installatör': { bg: 'bg-indigo-500', border: 'border-l-indigo-500', hex: '#6366f1' },
  'Pumpbil': { bg: 'bg-violet-600', border: 'border-l-violet-600', hex: '#7c3aed' },
  'Ställning': { bg: 'bg-purple-600', border: 'border-l-purple-600', hex: '#9333ea' },
  'Kranbil': { bg: 'bg-fuchsia-600', border: 'border-l-fuchsia-600', hex: '#c026d3' },
  'Markanbud': { bg: 'bg-amber-600', border: 'border-l-amber-600', hex: '#d97706' },

  // Grå - Admin / Autoberäkningar
  'Arbetsledning': { bg: 'bg-gray-500', border: 'border-l-gray-500', hex: '#6b7280' },
  'Framkörning': { bg: 'bg-gray-500', border: 'border-l-gray-500', hex: '#6b7280' },
  'Bystning': { bg: 'bg-gray-500', border: 'border-l-gray-500', hex: '#6b7280' },
  'Grovstäd': { bg: 'bg-gray-500', border: 'border-l-gray-500', hex: '#6b7280' },
  'Sophantering': { bg: 'bg-gray-500', border: 'border-l-gray-500', hex: '#6b7280' },

  // Övrigt
  'Finstad': { bg: 'bg-rose-600', border: 'border-l-rose-600', hex: '#e11d48' },
  'Försäkring': { bg: 'bg-pink-600', border: 'border-l-pink-600', hex: '#db2777' },
};

// Default färg för okända yrkesgrupper

/**
 * Hämta färg för en yrkesgrupp
 * @param {string} yrkesgrupp - Yrkesgruppens namn
 * @returns {Object|null} - Färgobjekt med bg, border och hex, eller null om ogiltig yrkesgrupp
 */
export const getYrkesgruppColor = (yrkesgrupp) => {
  // Returnera null för ogiltiga värden (null, undefined, 0, "0", tom sträng)
  if (!yrkesgrupp || yrkesgrupp === 0 || yrkesgrupp === '0') return null;
  // Returnera null om yrkesgruppen inte finns i listan (istället för default-färg)
  return YRKESGRUPP_COLORS[yrkesgrupp] || null;
};

/**
 * Hämta kategori för en yrkesgrupp (bakåtkompatibilitet)
 * @param {string} yrkesgrupp - Yrkesgruppens namn
 * @returns {string} - Kategorinamn
 */
export const getYrkesgruppCategory = (yrkesgrupp) => {
  if (!yrkesgrupp) return 'ovrigt';
  return YRKESGRUPP_COLORS[yrkesgrupp] ? yrkesgrupp : 'ovrigt';
};

// Golv-yrkesgrupper delar samma färg och slås ihop till EN "Golv"-post i legenden
const GOLV_YRKESGRUPPER = [
  'Nota', 'Slipa (lack)', 'Slipa (hårdvax)', 'Slipa (luta)', 'Slipa (grov)',
  'Fiskbensparkett', 'Fiskebenparkett', 'Massiv parkett (fallande L)', 'Mattläggning',
];

// Legenda för färgerna (för UI-visning) — golvpunkterna visas som en post: "Golv"
export const COLOR_LEGEND = [
  ...Object.entries(YRKESGRUPP_COLORS)
    .filter(([key]) => !key.includes('(ej ROT)') && !key.includes('(Ej ROT)') && !GOLV_YRKESGRUPPER.includes(key))
    .map(([label, colors]) => ({ label, color: colors.bg, hex: colors.hex })),
  { label: 'Golv', color: 'bg-lime-500', hex: '#84cc16' },
];
